import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
